<template>
<div class="page-builder">
  <div class="accordion" id="builder_accordion">
    <SortableBuilder :scope="['page', 'page_blocks_attributes']"  :content='content' v-slot='{ item, index }' :types='types' >
      <OrderedItem
        :scope="['page', 'page_blocks_attributes', index]"
        :initial-item="item"
        :position="index+1"
      >
        <Jumbotron v-if="item.item_type === 'jumbotron'" :page-block="item" :scope="['page', 'page_blocks_attributes', index]" :enabledLocales="enabledLocales" />

        <Image v-else-if="item.item_type === 'image'" :page-block="item" @update:page-block="newItem => {}" :scope="['page', 'page_blocks_attributes', index]" :enabledLocales="enabledLocales" />
        <Video v-else-if="item.item_type === 'video'" :page-block="item" @update:page-block="newItem => {}" :scope="['page', 'page_blocks_attributes', index]" />
        <LocaleRichTextField
          v-else-if="item.item_type === 'rich_text_area'"
          :initial-value="item.data?.localised_wysiwyg"
          :locales="enabledLocales"
          :scope="['page', 'page_blocks_attributes', index, 'localised_wysiwyg']"
          hide-label
          jumbotron-config
          @update="item.data?.localised_wysiwyg"
        />
      </OrderedItem>
    </SortableBuilder>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { EveryBuildableItem, ItemType, Locale, PropType } from "@/types";
import LocaleRichTextField from "@/components/backend/candidacy/form_builder/form_items/shared/LocaleRichTextField.vue";
import OrderedItem from "@/components/backend/candidacy/shared/OrderedItem.vue";
import Jumbotron from "./page_builder/page_blocks/Jumbotron.vue";
import SortableBuilder from "./shared/SortableBuilder.vue";
import Image from "./page_builder/page_blocks/Image.vue";
import Video from "./page_builder/page_blocks/Video.vue"
export default defineComponent({
  components: {
    Image,
    SortableBuilder,
    LocaleRichTextField,
    Jumbotron,
    OrderedItem,
    Video
  },
  name: "PageBuilder",
  props: {
    currentLocale: {
      type: String as PropType<Locale>,
      default() {
        return "en"
      }
    },
    content: {
      type: Array as PropType<EveryBuildableItem[]>,
      default() {
        return []
      }
    },
    availableLocales: {
      type: Array as PropType<Locale[]>,
      required: true,
    },
    enabledLocales: {
      type: Array as PropType<Locale[]>,
      required: true,
    },
    types: {
      type: Array as PropType<ItemType[]>,
      required: true
    }
  },
  data() {
    return {
      blocks: []
    }
  },
});
</script>

<style>
.page-builder {
  margin-bottom: 5%;
  .plus-btn {
    display: block;
    width: 10%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
  }
  .position-input {
    margin-right: auto;
    margin-left: auto;
    text-align: center;
  }
  .position-up {
    margin-top: auto;
  }
  .position-down {
    margin-bottom: auto;
  }
  .block-container{
    min-height: 200px;
    display: flex;
    flex-direction: row;
    justify-content: left;
    &:hover {
      box-shadow: 0px 0px 0 2px $primary;
    }
  }
  .block-option{
    display: flex;
    flex-direction: row;
    justify-content: center;
    .option-btn {
      margin-right: 5px;
    }
  }
  .image-input {
    margin-top: 20px;
  }
}
</style>
